// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3JTFE","select":"Header_select__3tZox","clinic":"Header_clinic__13xQF"};